<template>
  <v-dialog v-model="visible" persistent min-width="668px" max-width="668px">
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          fab
          flat
          color="gray-6"
          @click.native="close('icon')"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4 pt-0 pb-1">
        <p v-html="$t(`${namespace}.text`)" />
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />

        <a
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close('cancel')"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          color="accent"
          depressed
          round
          @click.native="close('proceed')"
        >
          {{ $t(`${namespace}.proceed`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ManyEmployessDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Views.Wizard.manyEmployessDialog'
    }
  },
  methods: {
    close (type) {
      if (type === 'icon') this.$ga.event('botao', 'clicou', 'fechar_muitoscolaboradores')
      if (type === 'cancel') this.$ga.event('botao', 'clicou', 'cancelar_muitoscolaboradores')
      if (type === 'proceed') this.$ga.event('botao', 'clicou', 'prosseguir_muitoscolaboradores')
      this.$emit('close')
    }
  }
}
</script>
